import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getUser'
})
export class GetUserPipe implements PipeTransform {

  transform(id: number, userlist: any[]): unknown {
    if (id && userlist) {
      const user = userlist.find(us => us.id === Number(id));
      if (user) {
        return user.login;
      } else {
        return id === -1 ? '' : id;
      }
    }
    return null;
  }

}
